import { usePostHttp } from "../../../../hooks/http/http.hook";
import type { SocialPostType } from "../../../../types/models/campaign.models.types";
import type {
  SocialCreatorType,
  SocialPlatforms,
} from "../../../../types/models/social.models.types";
import type { IBrandCampaign } from "./get-brand-campaigns.hook";

interface IBody {
  name: string;
  brand: string;
  coverImage: string | null;
  platform: string;
  socialPlatform: SocialPlatforms | null;
  socialPostType: SocialPostType | null;
  socialCreatorType: SocialCreatorType | null;
  aboutBrand: string | null;
  aboutCampaign: string | null;
  hashtags: string | null;
  mentions: string | null;
  do: string | null;
  dont: string | null;
}

interface IResponse {
  campaign: IBrandCampaign;
}

export function useCreateCampaignHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/campaigns",
  });
}
